<template>
  <div class="activityApply">
    <!-- 我要报名 -->
    <el-dialog
      title="活动报名"
      :visible.sync="dialogParams.dialogVisible"
      :before-close="beforeClose"
      @open="open"
    >
      <el-form label-position="top" :model="ruleForm" ref="ruleForm">
        <el-form-item
          label="姓名："
          prop="name"
          :rules="[{ required: true, message: '请填写姓名', trigger: 'blur' }]"
        >
          <el-input
            maxlength="15"
            show-word-limit
            v-model="ruleForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="手机："
          prop="mobile"
          :rules="[
            { required: true, message: '请填写手机号', trigger: 'blur' },
          ]"
        >
          <el-input v-model="ruleForm.mobile"> </el-input>
        </el-form-item>
        <el-form-item
          label="邮箱："
          prop="email"
          :rules="[{ required: true, message: '请填写邮箱', trigger: 'blur' }]"
          v-if="params.email_active"
        >
          <el-input v-model="ruleForm.email">
            <!--            <el-button slot="append" icon="el-icon-edit" @click="editInfo('email')"></el-button>-->
          </el-input>
        </el-form-item>
        <el-form-item
          label="性别："
          prop="sex"
          :rules="[{ required: true, message: '请选择性别', trigger: 'blur' }]"
          v-if="params.sex_active"
        >
          <el-select
            v-model="ruleForm.sex"
            placeholder="请选择"
          >
            <el-option
              v-for="item in sex"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="年龄："
          prop="age"
          :rules="[{ required: true, message: '请填写年龄', trigger: 'blur' }]"
          v-if="params.age_active"
        >
          <el-input v-model="ruleForm.age"></el-input>
        </el-form-item>
        <el-form-item
          label="通讯地址："
          prop="address"
          :rules="[
            { required: true, message: '请填写通讯地址', trigger: 'blur' },
          ]"
          v-if="params.address_active"
        >
          <el-input
            maxlength="100"
            show-word-limit
            v-model="ruleForm.address"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="单位："
          prop="company"
          :rules="[
            { required: true, message: '请填写所在单位', trigger: 'blur' },
          ]"
          v-if="params.company_active"
        >
          <el-input
            maxlength="30"
            show-word-limit
            v-model="ruleForm.company"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="职位："
          prop="position"
          :rules="[{ required: true, message: '请填写职位', trigger: 'blur' }]"
          v-if="params.profession_active"
        >
          <el-input
            maxlength="30"
            show-word-limit
            v-model="ruleForm.position"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="最高学历："
          prop="education"
          :rules="[
            { required: true, message: '请选择最高学历', trigger: 'blur' },
          ]"
          v-if="params.education_active"
        >
          <el-select
            v-model="ruleForm.education"
            placeholder="请选择"
          >
            <el-option
              v-for="item in EducationType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="毕业学校："
          prop="school"
          :rules="[
            { required: true, message: '请填写毕业学校', trigger: 'blur' },
          ]"
          v-if="params.school_active"
        >
          <el-input
            maxlength="30"
            show-word-limit
            v-model="ruleForm.school"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="证件类型："
          prop="id_type"
          :rules="[
            { required: true, message: '请选择证件类型', trigger: 'blur' },
          ]"
          v-if="params.certify_active"
        >
          <el-select
            v-model="ruleForm.id_type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in CertifyType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="证件号："
          :rules="[
            { required: true, message: '请填写证件号', trigger: 'blur' },
          ]"
          prop="id_number"
          v-if="params.certify_active"
        >
          <el-input
            v-model="ruleForm.id_number"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="params.custom_name + '：'"
          prop="custom"
          :rules="[
            {
              required: true,
              message: '请填写' + params.custom_name,
              trigger: 'blur',
            },
          ]"
          v-if="params.custom_active"
        >
          <el-input v-model="ruleForm.custom"></el-input>
        </el-form-item>
        <el-form-item
          label="个人图片："
          :rules="[
            { required: true, message: '请上传个人图片', trigger: 'blur' },
          ]"
          prop="image"
          v-if="params.image_active"
        >
          <div class="myupload">
            <div class="myupload_l">
              <upload-img
                :params="ruleForm"
                :apiParams="apiParams"
              ></upload-img>
              <input type="hidden" v-model="ruleForm.image" />
            </div>
            <div class="myupload_r">
              <p>1. 请上传个人图片。</p>
              <p>2. 文件格式：JPG/PNG/BMP/TIF/GIF；文件大小：500KB以内。</p>
              <p v-if="ruleForm.imagePath">
                <a
                  target="_blank"
                  style="
                    color: rgb(50, 130, 255);
                    cursor: pointer;
                    text-decoration: underline;
                  "
                  :href="ruleForm.imagePath"
                  download="图片"
                  >查看大图</a
                >
              </p>
            </div>
          </div>
        </el-form-item>
        <template v-for="(item, index) in ruleForm.activeForms">
          <el-form-item
              :label="item.name + '：'"
              :prop="'activeForms.'+index + '.value'"
              :rules="[
                {
                  required: true,
                  message: '请填写' + item.name,
                  trigger: 'blur',
                },
              ]"
              v-if="item.types === 10"
            >
              <el-input v-model="item.value"></el-input>
            </el-form-item>
          <el-form-item
            :label="item.name + '：'"
            :prop="'activeForms.'+index + '.value'"
            :rules="[
              {
                required: true,
                message: '请选择' + item.name,
                trigger: 'blur',
              },
            ]"
            v-else-if="item.types === 20"
          >
            <el-select
              v-model="item.value"
              placeholder="请选择"
              style="width:100%"
            >
              <el-option
                v-for="it in item.option"
                :label="it.value"
                :value="it.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="item.name + '：'"
            :prop="'activeForms.'+index + '.value'"
            :rules="[
              {
                required: true,
                message: '请选择' + item.name,
                trigger: 'blur',
              },
            ]"
            v-else-if="item.types === 30"
          >
            <el-radio-group v-model="item.value">
              <template v-for="it in item.option">
                <el-radio :label="it.value">{{ it.value }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="item.name + '：'"
            :prop="'activeForms.'+index + '.value'"
            :rules="[
              {
                required: true,
                message: '请选择' + item.name,
                trigger: 'blur',
              },
            ]"
            v-else-if="item.types === 40"
          >
            <el-checkbox-group v-model="item.value">
              <template v-for="it in item.option">
                <el-checkbox :label="it.value"></el-checkbox>
              </template>
            </el-checkbox-group>
          </el-form-item>
          </template>
      </el-form>
     
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="beforeClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import uploadImg from "@/components/file_upload/uploadImg.vue";
export default {
  components: {
    uploadImg,
  },
  props: {
    dialogParams: {
      type: Object,
    },
    //活动详情
    params: {
      type: Object,
    },
    activeForms: {
      type: Array,
    },
  },
  data() {
    return {
      //用户信息对象
      ruleForm: {
        image: "",
        imagePath: "",
        activeForms:[]
      },
      sex: [],
      CertifyType: [],
      EducationType: [],
      /** 文件上传参数*/
      apiParams: {
        params: {
          catalog: "CatalogActivityCover",
        },
        size: 0.5, //文件大小
        imgPath: "imagePath", //文件路径字段
        fileId: "image", //文件id字段
      },
    };
  },
  computed: {
    // 个人信息
    info() {
      return this.$store.state.info;
    },
    // 园区信息
    parkInfo() {
      return this.$store.state.parkInfo;
    },
    //企业信息
    company() {
      return this.$store.state.company;
    },
  },
  mounted(){
    this.needInfo();
  },
  methods: {
    // 监听个人信息
    needInfo(name) {
      
      let watchAch = this.$watch("activeForms", (val, oldVal) => {
        console.log(val);
        console.log(oldVal);
        if (val) {
          // this[name]();
          this.ruleForm = Object.assign({},this.ruleForm,{activeForms:this.activeForms})
          watchAch(); //取消监听
        }
      });
    },
    open() {
      // this.getUserInfo();
      this.getDict("Sex", "sex");
      this.getDict("CertifyType", "CertifyType");
      this.getDict("EducationType", "EducationType");
      if(this.activeForms.length){
        this.ruleForm = Object.assign({},this.ruleForm,{activeForms:this.activeForms})
      }else{
        this.needInfo();
      }
    },
    //查询用户信息
    getUserInfo() {
      this.api.getUserInfo({}).then((res) => {
        console.log(res);
        if (res.error["err_code"] !== 0) return;
        let obj = res.obj.list[0] || {};
        this.ruleForm = Object.assign({}, obj, {
          id_type: obj.id_type_id,
          education: obj.education_id,
        });
      });
    },
    //获取字典
    getDict(typeCode, key) {
      this.api
        .getDictionaries({
          pageSize: 999,
          typeCode: typeCode,
        })
        .then((res) => {
          if (res.error["err_code"] !== 0) return;
          this[key] = res.obj.list;
        });
    },
    //提交验证
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          this.$message.info("请检测必填项!");
          return false;
        }
      });
     
    },
    async save() {
      // await this.saveUserInfo();
      await this.saveSign();
    },
    //保存用户信息
    saveUserInfo() {
      let params = Object.assign({}, this.ruleForm, {
        education: this.ruleForm.education
          ? this.EducationType.find((it) => it.id === this.ruleForm.education)
              .code
          : "",
        id_type: this.ruleForm.id_type
          ? this.CertifyType.find((it) => it.id === this.ruleForm.id_type).code
          : "",
      });
      return this.api.updateUser(params, true).then((res) => {
        if (res.error["err_code"] !== 0) return;
      });
    },
    //创建报名
    saveSign() {
      let activeForms = this.activeForms;
      let signFormJson = activeForms.map(it => {
        let value = it.value;
        if (it.types === 40) {
          value = value.length ? value.join(',') : ''
        }
        return {
          name: it.name,
          value: value
        }
      })
      return this.api
        .createActiveSignFromLoginKey({
          active_id: this.params.id,
          ...this.ruleForm,
          education: this.ruleForm.education
            ? this.EducationType.find((it) => it.id === this.ruleForm.education)
                .code
            : "",
          id_type: this.ruleForm.id_type
            ? this.CertifyType.find((it) => it.id === this.ruleForm.id_type)
                .code
            : "",
            signFormJson: JSON.stringify(signFormJson)
        })
        .then((res) => {
          if (res.error["err_code"] !== 0) return;
          this.$message.success("报名成功");
          this.$emit("confirm", true);
          this.beforeClose();
        });
    },
    //跳转到修改手机和邮箱页面
    editInfo(type) {
      if (type === "mobile") {
        let routerUrl = this.$router.resolve({
          path: "/personal_center/account_settings/mobile_phone_binding",
          query: {},
        });
        window.open(routerUrl.href, "_blank");
      }
      if (type === "email") {
        let routerUrl = this.$router.resolve({
          path: "/personal_center/account_settings/mail_binding",
          query: {},
        });
        window.open(routerUrl.href, "_blank");
      }
    },
    beforeClose() {
      Object.assign(this.$data, this.$options.data());
      this.dialogParams.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.activityApply {
  .el-dialog {
    width: 560px;
    .el-form{
    
    }
  }
  .el-input-240 {
    width: 240px !important;
  }
  .el-form-item {
    .el-form-item__label {
      padding-bottom: 0;
    }
  }
  // 上传样式start
  .myupload {
    display: flex;

    .myupload_r {
      margin-left: 10px;
      font-size: 12px;
      color: #999;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      p {
        white-space: normal;
        line-height: 18px;
      }
    }
  }
}
</style>
